var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurtainsWindowSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.992 511.992",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 95.996,
    y: 37.335,
    style: {
      fill: "#5D9CEC"
    },
    width: 351.99,
    height: 306.81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCD1D9"
    },
    d: "M309.323,37.339H202.668c-5.89,0-10.671,4.766-10.671,10.672c0,5.891,4.781,10.655,10.671,10.655 h42.656v287.987c0,5.906,4.781,10.688,10.672,10.688s10.672-4.781,10.672-10.688V58.666h42.655c5.89,0,10.671-4.765,10.671-10.655 C319.994,42.104,315.213,37.339,309.323,37.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M441.773,357.341c5.891,0,10.672-4.781,10.672-10.688c0-5.874-4.781-10.655-10.672-10.655H70.218 c-5.891,0-10.672,4.781-10.672,10.655c0,5.906,4.781,10.688,10.672,10.688c-5.891,0-10.672,4.75-10.672,10.656 s4.781,10.656,10.672,10.656h371.556c5.891,0,10.672-4.75,10.672-10.656S447.664,357.341,441.773,357.341z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D468"
    },
    d: "M0,506.651h117.326v-10.656c0-51.218-11.969-93.404-22.031-119.811 c-6.125-16.062-12.249-28.344-16.546-36.187c13.452-8.219,38.218-26,62.968-57.405c20.858-26.477,37.468-57.288,49.358-91.601 c14.765-42.593,22.249-90.701,22.249-142.981V37.339H0V506.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D468"
    },
    d: "M298.667,37.339v10.672c0,52.124,7.484,100.139,22.249,142.7 c11.891,34.281,28.5,65.108,49.359,91.632c24.766,31.499,49.546,49.374,62.998,57.624c-4.312,7.843-10.452,20.124-16.577,36.218 c-10.062,26.406-22.03,68.593-22.03,119.811v10.656h117.326V37.339H298.667z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M191.997,37.339c-5.891,0-10.672-4.781-10.672-10.672V16.011c0-5.906,4.781-10.672,10.672-10.672 s10.671,4.766,10.671,10.672v10.656C202.668,32.557,197.888,37.339,191.997,37.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M149.325,37.339c-5.891,0-10.655-4.781-10.655-10.672V16.011c0-5.906,4.765-10.672,10.655-10.672 s10.672,4.766,10.672,10.672v10.656C159.997,32.557,155.216,37.339,149.325,37.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M106.67,37.339c-5.891,0-10.672-4.781-10.672-10.672V16.011c0-5.906,4.781-10.672,10.672-10.672 s10.656,4.766,10.656,10.672v10.656C117.326,32.557,112.56,37.339,106.67,37.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M63.999,37.339c-5.891,0-10.672-4.781-10.672-10.672V16.011c0-5.906,4.781-10.672,10.672-10.672 s10.672,4.766,10.672,10.672v10.656C74.671,32.557,69.89,37.339,63.999,37.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M21.328,37.339c-5.891,0-10.656-4.781-10.656-10.672V16.011c0-5.906,4.766-10.672,10.656-10.672 s10.671,4.766,10.671,10.672v10.656C31.999,32.557,27.219,37.339,21.328,37.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M490.664,37.339c-5.891,0-10.672-4.781-10.672-10.672V16.011c0-5.906,4.781-10.672,10.672-10.672 s10.656,4.766,10.656,10.672v10.656C501.32,32.557,496.555,37.339,490.664,37.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M447.992,37.339c-5.891,0-10.672-4.781-10.672-10.672V16.011c0-5.906,4.781-10.672,10.672-10.672 s10.672,4.766,10.672,10.672v10.656C458.664,32.557,453.883,37.339,447.992,37.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M405.321,37.339c-5.89,0-10.655-4.781-10.655-10.672V16.011c0-5.906,4.766-10.672,10.655-10.672 c5.891,0,10.672,4.766,10.672,10.672v10.656C415.993,32.557,411.212,37.339,405.321,37.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M362.666,37.339c-5.891,0-10.672-4.781-10.672-10.672V16.011c0-5.906,4.781-10.672,10.672-10.672 s10.656,4.766,10.656,10.672v10.656C373.322,32.557,368.557,37.339,362.666,37.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M319.994,37.339c-5.89,0-10.671-4.781-10.671-10.672V16.011c0-5.906,4.781-10.672,10.671-10.672 c5.891,0,10.672,4.766,10.672,10.672v10.656C330.666,32.557,325.885,37.339,319.994,37.339z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M501.32,26.667H10.672C4.781,26.667,0,21.901,0,16.011C0,10.105,4.781,5.339,10.672,5.339H501.32 c5.891,0,10.672,4.766,10.672,10.672C511.992,21.901,507.211,26.667,501.32,26.667z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC153"
    },
    d: "M42.655,346.653c-2.578,0-5.172-0.938-7.219-2.812c-4.328-4-4.609-10.75-0.609-15.094 c28.328-30.655,51.405-64.397,68.608-100.256c13.766-28.703,23.828-58.843,29.906-89.593c8.312-41.999,7.188-76.843,5.438-89.404 c-0.828-5.828,3.234-11.219,9.062-12.047c5.828-0.812,11.219,3.219,12.047,9.047c0.234,1.594,5.469,39.765-5.422,95.576 c-6.359,32.624-16.968,64.608-31.515,95.045c-18.156,38.008-42.53,73.726-72.452,106.132 C48.405,345.497,45.53,346.653,42.655,346.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC153"
    },
    d: "M21.328,346.653c-2.203,0-4.438-0.656-6.344-2.093c-4.734-3.5-5.734-10.188-2.219-14.906 c20.655-27.874,47.53-81.132,58.171-176.567c6.453-57.765,3.781-103.982,3.75-104.436c-0.359-5.891,4.125-10.938,10-11.297 c5.874-0.375,10.937,4.125,11.296,10c0.109,1.938,2.812,48.202-3.797,107.717c-3.891,35.077-10.233,67.405-18.858,96.123 c-10.891,36.305-25.5,66.991-43.422,91.147C27.812,345.184,24.594,346.653,21.328,346.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC153"
    },
    d: "M63.999,506.651c-0.125,0-0.234,0-0.359,0c-5.891-0.188-10.5-5.125-10.297-11.031 c2.125-62.187-29.765-155.216-30.093-156.122c-1.922-5.594,1.031-11.656,6.593-13.594c5.578-1.906,11.641,1.031,13.562,6.594 c1.375,3.969,33.516,97.748,31.25,163.872C74.468,502.12,69.733,506.651,63.999,506.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC153"
    },
    d: "M469.336,346.653c-2.875,0-5.75-1.156-7.844-3.405c-29.922-32.406-54.296-68.124-72.451-106.132 c-14.547-30.437-25.156-62.421-31.516-95.045c-10.891-55.812-5.656-93.982-5.422-95.576c0.828-5.828,6.234-9.891,12.062-9.047 c5.828,0.828,9.875,6.219,9.047,12.047l0,0c-1.75,12.562-2.875,47.405,5.438,89.404c6.078,30.75,16.141,60.89,29.905,89.593 c17.203,35.858,40.28,69.601,68.608,100.256c4,4.344,3.719,11.094-0.609,15.094C474.508,345.716,471.914,346.653,469.336,346.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC153"
    },
    d: "M490.664,346.653c-3.266,0-6.484-1.469-8.578-4.312c-17.922-24.156-32.531-54.843-43.422-91.147 c-8.625-28.718-14.968-61.046-18.858-96.123c-6.609-59.515-3.906-105.779-3.797-107.717c0.359-5.875,5.422-10.359,11.297-10 c5.874,0.359,10.358,5.422,9.999,11.297c-0.031,0.594-2.688,46.749,3.75,104.436c5.875,52.671,20.734,126.068,58.172,176.567 c3.516,4.719,2.516,11.406-2.219,14.906C495.101,345.997,492.867,346.653,490.664,346.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC153"
    },
    d: "M447.992,506.651c-5.734,0-10.469-4.531-10.656-10.281c-2.266-66.124,29.875-159.903,31.25-163.872 c1.922-5.562,7.984-8.5,13.562-6.594c5.562,1.938,8.516,8,6.594,13.594c-0.328,0.906-32.219,93.998-30.094,156.122 c0.203,5.906-4.406,10.844-10.297,11.031C448.226,506.651,448.101,506.651,447.992,506.651z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M85.327,346.653H0v-21.312h85.327c5.89,0,10.671,4.75,10.671,10.656S91.217,346.653,85.327,346.653z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M425.946,346.653h85.327v-21.312h-85.327c-5.891,0-10.672,4.75-10.672,10.656 S420.056,346.653,425.946,346.653z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurtainsWindowSvgrepoCom);
export default __webpack_public_path__ + "static/media/curtains-window-svgrepo-com.0e275cb3a8829833b6d3f110b77889e6.svg";
export { ForwardRef as ReactComponent };